import React from "react";
import { CircularProgress, Alert } from "@mui/material";
import DataTableBase from "./dataTableBase";
import { deviceColumns } from "./columnDefs";
import { useDevices } from "../../hooks/useDevices";

export default function DeviceBrandDevicesTable(props) {
  const { data: devices = [], isLoading, error } = useDevices();

  const brandID = props.brandID;

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Alert severity="error">Error loading devices: {error.message}</Alert>
    );
  }

  const filteredDevices = devices.filter(
    (device) => device.device_brand_id === brandID
  );

  return (
    <DataTableBase
      title={"Devices"}
      data={filteredDevices || []}
      columns={deviceColumns}
      orderby="time_updated"
    />
  );
}
